import { CheckCircleIcon } from '@/shared/assets/icons/check-circle-icon';
import { ChevronDoubleLeftIcon } from '@/shared/assets/icons/chevron-double-left-icon';
import { CircleIcon } from '@/shared/assets/icons/circle-icon';
import { ClockXIcon } from '@/shared/assets/icons/clock-x-icon';
import { DotCircleIcon } from '@/shared/assets/icons/dot-circle';
import { ExclamationCircleIcon } from '@/shared/assets/icons/exclamation-circle-icon';
import { PlayCircleIcon } from '@/shared/assets/icons/play-circle-icon';
import { SlashCircleIcon } from '@/shared/assets/icons/slash-circle-icon';
import { XCircleIcon } from '@/shared/assets/icons/x-circle-icon';
import {
  TJobStatusColor,
  TJobStatusIcon,
} from '@/shared/features/jobs/hooks/use-job-status/use-job-status.types';
import {
  JobStatusEnum,
  PipelineExecutionStatusEnum,
} from '@/shared/types/types.generated';

export const jobStatusColor: TJobStatusColor = {
  [PipelineExecutionStatusEnum.Canceled]: 'grey',
  [PipelineExecutionStatusEnum.Failed]: 'red',
  [PipelineExecutionStatusEnum.FailedIgnore]: 'yellow',
  [PipelineExecutionStatusEnum.NotStarted]: 'grey',
  [PipelineExecutionStatusEnum.Pending]: 'orange',
  [PipelineExecutionStatusEnum.Processing]: 'blue',
  [PipelineExecutionStatusEnum.Skipped]: 'grey',
  [PipelineExecutionStatusEnum.Success]: 'green',
  [PipelineExecutionStatusEnum.TimedOut]: 'orange',
  [PipelineExecutionStatusEnum.Warning]: 'yellow',
  [JobStatusEnum.Expired]: 'orange',
};

export const backupJobStatusColor: TJobStatusColor = {
  [PipelineExecutionStatusEnum.Canceled]: 'grey',
  [PipelineExecutionStatusEnum.Failed]: 'red',
  [PipelineExecutionStatusEnum.FailedIgnore]: 'yellow',
  [PipelineExecutionStatusEnum.NotStarted]: 'grey',
  [PipelineExecutionStatusEnum.Pending]: 'orange',
  [PipelineExecutionStatusEnum.Processing]: 'blue',
  [PipelineExecutionStatusEnum.Skipped]: 'green',
  [PipelineExecutionStatusEnum.Success]: 'yellow',
  [PipelineExecutionStatusEnum.TimedOut]: 'orange',
  [PipelineExecutionStatusEnum.Warning]: 'yellow',
  [JobStatusEnum.Expired]: 'orange',
};

export const jobStatusIcon: TJobStatusIcon = {
  [PipelineExecutionStatusEnum.Canceled]: <SlashCircleIcon />,
  [PipelineExecutionStatusEnum.Failed]: <XCircleIcon />,
  [PipelineExecutionStatusEnum.FailedIgnore]: <ExclamationCircleIcon />,
  [PipelineExecutionStatusEnum.NotStarted]: <CircleIcon />,
  [PipelineExecutionStatusEnum.Pending]: <DotCircleIcon />,
  [PipelineExecutionStatusEnum.Processing]: <PlayCircleIcon />,
  [PipelineExecutionStatusEnum.Skipped]: <ChevronDoubleLeftIcon />,
  [PipelineExecutionStatusEnum.Success]: <CheckCircleIcon />,
  [PipelineExecutionStatusEnum.TimedOut]: <ClockXIcon />,
  [PipelineExecutionStatusEnum.Warning]: <ExclamationCircleIcon />,
  [JobStatusEnum.Expired]: <ClockXIcon />,
};
